import './App.css';
import Home from "./pages/home/home.pages"
import DetailPage from './pages/detail-page/detail-page.page';
import {Switch, Route, Link, Redirect, useLocation} from 'react-router-dom'
import { AdBlockDetectedWrapper } from "adblock-detect-react";


function App() {
  return (
    <div className="App">
      {/* <AdBlockDetectedWrapper> */}
        <Switch>
          <Route exact path="/:id" render={(props) => <DetailPage id={props.match.params.id} />}/>
          <Route path="/" component={Home}/>
        </Switch>
      {/* </AdBlockDetectedWrapper> */}
    </div>
  );
}

export default App;
